export const DASHBOARD_MOBILE_MEDIA_QUERY = '(max-width: 1000px)';
